import { Outlet } from 'react-router-dom';
import { AuthLanguageButton } from './AuthLanguageButton';
import { useTranslation } from 'react-i18next';
import { config } from '@/lib/config';

export function AuthLayout() {
  const { t, i18n } = useTranslation();
  const arabic = i18n.resolvedLanguage?.startsWith('ar') ?? false;
  const publicOrigin = config.platformDomain ? `https://${config.platformDomain}` : window.location.origin;
  const websiteUrl = `${publicOrigin}${arabic ? '/ar/' : '/'}`;
  const logo = `heglo-logo-${arabic ? 'arabic' : 'horizontal'}`;
  return (
    <div className="heglo-platform-auth" dir={arabic ? 'rtl' : 'ltr'}>
      <aside className="heglo-auth-brand">
        <a href={websiteUrl} className="heglo-auth-logo"><img src={`/${logo}-dark.svg`} alt={arabic ? 'هيجلو' : 'Heglo'} width="176" height="48" /></a>
        <img className="heglo-auth-pattern" src="/heglo-mark.svg" alt="" aria-hidden="true" />
        <div className="heglo-auth-brand-copy"><p className="heglo-auth-title">{t('auth.login.platformTitle')}</p><p>{t('auth.login.brandingDescription')}</p></div>
        <span className="heglo-auth-brand-line" aria-hidden="true" />
      </aside>
      <main className="heglo-auth-main"><h1 className="sr-only">{t('auth.login.platformTitle')}</h1>
        <div className="heglo-auth-form">
          <div className="heglo-auth-form-header"><a href={websiteUrl}><img src={`/${logo}-light.svg`} alt={arabic ? 'هيجلو' : 'Heglo'} width="132" height="36" /></a><AuthLanguageButton /></div>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
